// Sessions-remaining math is package-scoped, not client-lifetime-scoped.
// Pass packages.sessions_completed (per-package counter), NOT
// clients.previous_session_number (client lifetime across all packages).
// The lifetime number can exceed any single package's size and produces
// nonsense remaining counts.

export function calculateSessionsRemaining(
  packageSize: number,
  packageSessionsCompleted: number
): number {
  // Guard against non-finite inputs (NaN/Infinity) which would otherwise
  // propagate garbage to the UI under data drift. Remaining is bounded to
  // [0, size]: it can't go negative or exceed the package size.
  const size = Number.isFinite(packageSize) ? Math.max(0, packageSize) : 0;
  const done = Number.isFinite(packageSessionsCompleted)
    ? Math.max(0, packageSessionsCompleted)
    : 0;
  return Math.min(size, Math.max(0, size - done));
}

export function calculateProgressPercent(
  packageSize: number,
  packageSessionsCompleted: number
): number {
  if (!Number.isFinite(packageSize) || packageSize <= 0) return 0;
  const done = Number.isFinite(packageSessionsCompleted)
    ? Math.max(0, packageSessionsCompleted)
    : 0;
  // Clamp to [0, 100] — both ends, so negative or overflow inputs can't
  // render an out-of-range progress bar.
  return Math.min(100, Math.max(0, Math.round((done / packageSize) * 100)));
}
